export const REQUEST_SOURCE_HEADER = 'x-request-source';
export const ANDROID_APP_VERSION_HEADER = 'x-app-version-android';
export const IOS_APP_VERSION_HEADER = 'x-app-version-ios';
export const MOBILE_APP_NAME_HEADER = 'x-mobile-app-name';
export const OTA_BUNDLE_VERSION_HEADER = 'x-ota-bundle-version';

export const DEV_UTILS_HEADER = 'x-dev-utils';

export const REQUEST_SOURCES = {
  MOBILE_APP: 'mobile-app',
};
